var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWarningIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 79,
    viewBox: "0 0 87 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87 72.68c0 2.054-.716 3.62-2.15 4.7C83.417 78.46 81.66 79 79.574 79H7.426c-2.085 0-3.843-.553-5.276-1.659C.717 76.235 0 74.681 0 72.68c0-1.58.469-3.186 1.407-4.819L37.442 4.345C39.162 1.448 41.194 0 43.54 0c2.345 0 4.325 1.448 5.94 4.345L85.594 67.94C86.531 69.625 87 71.205 87 72.68zM48.933 32.311V20.777H38.067v11.534c0 .737.053 1.435.157 2.093.104.659.247 1.396.43 2.212.182.817.325 1.515.43 2.094l2.032 12.798h4.612l2.11-12.798c.105-.527.26-1.211.47-2.054.208-.843.364-1.593.468-2.252.104-.658.157-1.356.157-2.093zm0 30.573c0-1.527-.535-2.818-1.603-3.871s-2.358-1.58-3.87-1.58c-1.458 0-2.722.527-3.79 1.58-1.069 1.053-1.603 2.344-1.603 3.871 0 1.527.535 2.83 1.603 3.91s2.332 1.62 3.79 1.62c1.512 0 2.802-.54 3.87-1.62 1.069-1.08 1.603-2.383 1.603-3.91z",
    fill: "#D12421"
  })));
}

export default SvgWarningIcon;